var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.116 4.074H32.07a6.842 6.842 0 0 0-6.824 6.825v87.385a6.846 6.846 0 0 0 6.824 6.827h45.046a6.839 6.839 0 0 0 6.824-6.824V10.898a6.842 6.842 0 0 0-6.824-6.824zm-29.728 4.92h14.41a.827.827 0 1 1 0 1.653h-14.41a.827.827 0 1 1 0-1.654zm7.205 92.705a3.411 3.411 0 1 1-.001-6.823 3.411 3.411 0 0 1 .001 6.823zm24.598-9.217H29.995V14.897H79.19v77.585z",
    fill: "#E3E3E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryPhone);
export default __webpack_public_path__ + "static/media/category-phone.a7a99b1f8df842201701a102ec6392a3.svg";
export { ForwardRef as ReactComponent };